import Layout from '../../layout/index'

const memberRouter = {
  path: '/member',
  component: Layout,
  redirect: '/member/index',
  children: [
    {
      path: 'index',
      name: 'basicInfo',
      component: () => import('../../views/member/index')
    },
    {
      path: 'security',
      name: 'security',
      component: () => import('../../views/member/security')
    },
    {
      path: 'reserve',
      name: 'reserve',
      component: () => import('../../views/member/reserve')
    },
    {
      path: 'family',
      name: 'family',
      component: () => import('../../views/member/family')
    }
  ]
}
export default memberRouter
